export const CLIENT_STATUS_INACTIVE = 0;
export const CLIENT_STATUS_ACTIVE = 1;

function getClientStatusDescription(status, translations) {
  switch (status) {
    case CLIENT_STATUS_ACTIVE:
      return translations.statusActive;
    case CLIENT_STATUS_INACTIVE:
      return translations.statusInactive;
    default:
      return translations.statusUnknown;
  }
}

export default getClientStatusDescription;
